import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { DateField, ReferenceField, SelectField, Show, SimpleShowLayout, TextField } from 'react-admin';

export const CashFlowAdjustmentShow: React.FC = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <TextField label="Druh" source="text" />
        <TextField label="Suma" source="period.expectedAmount.amount" />
        <DateField label="Prvá platba" locales="sk" source="period.referenceDate" />
        <TextField label="Opakovať každých" source="period.periodCount" />
        <SelectField choices={PERIOD_TYPE_CHOICES} label="" source="period.periodTypeCode" />
        <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" showTime={true} source="updateTimestamp" />
      </SimpleShowLayout>
    </Show>
  );
};
